


































































































































































import {Component, Watch, Mixins} from 'vue-property-decorator'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'
import FilterToggle from '@/components/FilterToggle.vue'
import FilterDapp from '@/components/filters/FilterDapp.vue'
import {Dapp} from '@/model/resource/Dapp'
import {DappCollection} from '@/model/collection/DappCollection'
import {ListDappSchema} from '@/schema/resource/Dapp/ListDappSchema'
import {ExportDappSchema} from '@/schema/resource/Dapp/ExportDappSchema'
import {$} from '@/facade'

@Component({
  components: {
    FilterToggle,
    FilterDapp,
  },
})
export default class ListDappView extends Mixins(MixinRouteMatch) {
  schema = new ListDappSchema()
  collection = new DappCollection()
  filterOpen = false

  goToPersistView(item: Dapp) {
    $.nav.pushByName('editDapp', item.$id)
  }

  async created() {
    this.collection.inActiveDevelopment = null
    this.collection.isDapp = false
    if (this.hasQueryParams) {
      this.updateObjectFromRoute(this.collection)
    }
    await $.await.run('hardQuery', () => this.collection.queryAsPage())
  }

  async removeItem(item: Dapp) {
    await $.dialog.remove(item)
    await item.removeDapp()
    await this.collection.queryAsPage()
  }

  async downloadXlsx() {
    const {...params} = this.collection.params

    const coll = new DappCollection().clearFilters().addFilter(params)

    await coll.listExportDapp()
    $.xlsx.downloadFromSchema(coll.items, new ExportDappSchema())
  }

  async resyncTxData() {
    await $.dialog.resyncTxData()
    await $.await.run('resyncTxData', async () => {
      $.toast.info(
        'system.info.resyncTxDataBody',
        'system.info.resyncTxDataTitle'
      )
      await $.utils.sleep(10000)
    })
  }

  @Watch('collection', {deep: true})
  collectionEvent() {
    this.updateRouteFromObject(this.collection)
  }
}
